import { render, staticRenderFns } from "./PartsPanel.vue?vue&type=template&id=00c2723a&scoped=true&"
import script from "./PartsPanel.vue?vue&type=script&lang=js&"
export * from "./PartsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c2723a",
  null
  
)

export default component.exports